import React from 'react';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
export function PrivacyPage() {
  return <div className="min-h-screen bg-[#FAF9F7]" data-id="element-322">
      <Navigation data-id="element-323" />

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 py-24 sm:py-32" data-id="element-324">
        <article className="prose prose-lg max-w-none" data-id="element-325">
          <h1 className="text-4xl sm:text-5xl font-semibold text-gray-900 mb-8" data-id="element-326">
            Privacy Policy
          </h1>

          <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-327">
            Last updated: January 2026
          </p>

          <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-328">
            Andoe ("we", "us", or "our") values your privacy. This Privacy
            Policy explains how we collect, use, share, and protect information
            when you use Andoe, including our website and services (the
            "Service").
          </p>

          <p className="text-lg text-gray-700 leading-relaxed mb-12" data-id="element-329">
            By using Andoe, you agree to the practices described in this policy.
          </p>

          <div className="space-y-12" data-id="element-330">
            <section data-id="element-331">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-332">
                1. Information We Collect
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-333">
                We collect only the information necessary to operate, secure,
                and improve Andoe.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-334">
                Information you provide
              </h3>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-335">
                <li data-id="element-336">
                  <strong data-id="element-337">Account information:</strong> name, email address,
                  login credentials
                </li>
                <li data-id="element-338">
                  <strong data-id="element-339">Billing information:</strong> when you purchase a plan
                  (processed by our payment processor)
                </li>
                <li data-id="element-340">
                  <strong data-id="element-341">Customer content:</strong> prompts, inputs,
                  configuration, and other content you submit while using the
                  Service
                </li>
                <li data-id="element-342">
                  <strong data-id="element-343">Communications:</strong> messages you send to us
                  (support, feedback, inquiries)
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-344">
                Information collected automatically
              </h3>
              <ul className="space-y-2 text-lg text-gray-700" data-id="element-345">
                <li data-id="element-346">
                  <strong data-id="element-347">Usage data:</strong> pages visited, features used,
                  actions taken within the product
                </li>
                <li data-id="element-348">
                  <strong data-id="element-349">Technical data:</strong> IP address, browser type,
                  device type, timestamps
                </li>
                <li data-id="element-350">
                  <strong data-id="element-351">Cookies and similar technologies:</strong> used for
                  authentication, session management, and basic analytics
                </li>
              </ul>
            </section>

            <section data-id="element-352">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-353">
                2. How We Use Information
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-354">
                We use information to:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-355">
                <li data-id="element-356">Provide and operate the Service</li>
                <li data-id="element-357">Authenticate users and manage accounts</li>
                <li data-id="element-358">Process prompts and generate analytics and insights</li>
                <li data-id="element-359">Communicate with you about the product</li>
                <li data-id="element-360">
                  Monitor performance, prevent abuse, and maintain security
                </li>
                <li data-id="element-361">Improve features, usability, and reliability</li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-362">
                We do not sell your personal information.
              </p>
            </section>

            <section data-id="element-363">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-364">
                3. Customer Content and Prompts
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-365">
                Content you submit to Andoe, such as prompts, queries, and
                configuration data, is used solely to:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-366">
                <li data-id="element-367">Provide functionality</li>
                <li data-id="element-368">Generate analytics and outputs for you</li>
                <li data-id="element-369">Operate and improve the Service</li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-370">
                We do not use your customer content for advertising purposes.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-371">
                You are responsible for ensuring you have the rights to submit
                any content, including client or third-party data.
              </p>
            </section>

            <section data-id="element-372">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-373">
                4. Service Providers and Processing
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-374">
                We use trusted third-party service providers to help operate
                Andoe, such as:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-375">
                <li data-id="element-376">Hosting and infrastructure providers</li>
                <li data-id="element-377">Authentication providers</li>
                <li data-id="element-378">Analytics and monitoring tools</li>
                <li data-id="element-379">Payment processors</li>
                <li data-id="element-380">AI model and API providers where applicable</li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-381">
                These providers may process data only as necessary to provide
                their services to us and are contractually obligated to protect
                it.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-382">
                Your data may be processed in Canada, the United States, and
                other jurisdictions where our service providers operate.
              </p>
            </section>

            <section data-id="element-383">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-384">
                5. Cookies and Authentication
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-385">
                We use essential cookies and similar technologies to:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-386">
                <li data-id="element-387">Maintain login sessions</li>
                <li data-id="element-388">Authenticate users</li>
                <li data-id="element-389">Protect accounts and prevent abuse</li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-390">
                These are required for the Service to function and cannot be
                disabled without affecting functionality.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-391">
                You can control non-essential cookies through your browser
                settings.
              </p>
            </section>

            <section data-id="element-392">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-393">
                6. Data Retention
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-394">
                We retain personal information and customer content while your
                account is active.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-395">
                After account termination, we may retain data for a limited
                period for:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-396">
                <li data-id="element-397">Legal compliance</li>
                <li data-id="element-398">Security and fraud prevention</li>
                <li data-id="element-399">Dispute resolution</li>
                <li data-id="element-400">Enforcement of our Terms</li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-401">
                We are not obligated to retain data after account termination.
              </p>
            </section>

            <section data-id="element-402">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-403">
                7. Data Security
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-404">
                We implement reasonable administrative, technical, and
                organizational safeguards designed to protect your information.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-405">
                However, no system is perfectly secure, and we cannot guarantee
                absolute security.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-406">
                You are responsible for maintaining the confidentiality of your
                login credentials and for using strong passwords.
              </p>
            </section>

            <section data-id="element-407">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-408">
                8. Data Sharing
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-409">
                We do not sell your data.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-410">
                We may share information only:
              </p>
              <ul className="space-y-2 text-lg text-gray-700" data-id="element-411">
                <li data-id="element-412">With service providers that help us operate Andoe</li>
                <li data-id="element-413">To comply with legal obligations</li>
                <li data-id="element-414">
                  To protect the rights, safety, and security of Andoe and its
                  users
                </li>
                <li data-id="element-415">
                  In connection with a merger, acquisition, or sale of assets
                  (with appropriate safeguards)
                </li>
              </ul>
            </section>

            <section data-id="element-416">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-417">
                9. International Users
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-418">
                Andoe is operated from Canada. If you access the Service from
                outside Canada, you understand that your information may be
                processed in Canada and other jurisdictions where our providers
                operate.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-419">
                By using Andoe, you consent to this cross-border processing.
              </p>
            </section>

            <section data-id="element-420">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-421">
                10. Your Rights
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-422">
                Depending on your location, you may have rights to:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-423">
                <li data-id="element-424">Access your personal information</li>
                <li data-id="element-425">Request correction or deletion</li>
                <li data-id="element-426">Withdraw consent where applicable</li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-427">
                You can make requests by contacting us at the email below.
              </p>
            </section>

            <section data-id="element-428">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-429">
                11. Changes to This Policy
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-430">
                We may update this Privacy Policy from time to time. The most
                current version will always be available on our website.
                Continued use of the Service after changes take effect
                constitutes acceptance of the updated policy.
              </p>
            </section>

            <section data-id="element-431">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-432">
                12. Contact
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-433">
                If you have questions about this Privacy Policy or your data,
                contact us at:
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mt-4" data-id="element-434">
                Email:{' '}
                <a href="mailto:jason@andoe.work" className="text-blue-600 hover:text-blue-700 underline" data-id="element-435">
                  jason@andoe.work
                </a>
              </p>
            </section>
          </div>
        </article>
      </main>

      <Footer data-id="element-436" />
    </div>;
}